import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage(null);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ email })
            });

            const data = await response.json();

            if (response.ok) {
                setMessage({
                    type: 'success',
                    text: data.message || 'Hvis e-postadressen finnes i systemet, vil du motta en lenke for å tilbakestille passordet.'
                });
                setEmail(''); // Clear the form
            } else {
                setMessage({
                    type: 'error',
                    text: data.message || 'Noe gikk galt. Prøv igjen.'
                });
            }
        } catch (error) {
            console.error('Forgot password error:', error);
            setMessage({
                type: 'error',
                text: 'Kunne ikke koble til serveren. Prøv igjen senere.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-form">
                <div className="auth-header">
                    <h2>Glemt passord?</h2>
                    <p>Skriv inn e-postadressen din, så sender vi deg en lenke for å tilbakestille passordet.</p>
                </div>

                <form onSubmit={handleSubmit}>
                    {message && (
                        <div className={`auth-${message.type}`}>
                            {message.text}
                        </div>
                    )}

                    <div className="auth-form-group">
                        <label htmlFor="email" className="sr-only">
                            E-postadresse
                        </label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="first-input last-input"
                            placeholder="E-postadresse"
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="auth-submit"
                    >
                        {isSubmitting && <span className="spinner"></span>}
                        {isSubmitting ? 'Sender...' : 'Send tilbakestillingslenke'}
                    </button>

                    <div className="auth-link">
                        <Link to="/login">
                            ← Tilbake til innlogging
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
